<template>
  <div>
    <div class="list-con">
      <el-table ref="filterTable" :data="tabelData" tooltip-effect="dark" style="width: 100%"
        @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column :prop="item.key" :label="item.label" v-for="item in dataSource" :key="item.key"
          :width="item.width || ''">
          <template slot-scope="scope">
            <div class="text" v-if="!slotmap.includes(item.key)">
              {{ scope.row[item.key] }}
            </div>
            <div class="text" v-else-if="item.key == 'last_change_time'">
              {{ formatDate(scope.row[item.key]) }}
            </div>
            <div v-else-if="item.key == 'menu'" class="tab-menu" style="cursor: pointer"
              @click="show_centerDialogVisible(scope.row)">
              查看图片
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination background layout="prev, pager, next" :total="numdata"
      style="margin-top: 30px; float: right; margin-right: 60px" :current-page="current_page" :page-size="page_size"
      @current-change="handleCurrentChange" @prev-click="handleCurrentChange_prev"
      @next-click="handleCurrentChange_next">
    </el-pagination>
    <el-dialog title="查看图片" :visible.sync="centerDialogVisible" width="70%" center>
      <img :src="centerDialogVisible_image" alt="" style="width: 100%" />
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getpeoWarnlist } from "../../api/index";
export default {
  props: {
    searchval: {
      type: String,
      default() {
        return "";
      },
    },
    searchtype: {
      type: String,
      default() {
        return "";
      },
    },
  },
  watch: {
    searchval(newValue, oldValue) {
      if (newValue != oldValue) {
        this.current_page = 1;
        this.getData();
      }
    },
    searchtype(newValue, oldValue) {
      if (newValue != oldValue) {
        this.current_page = 1;
        this.getData();
      }
    }
  },
  mounted() {
    this.getData();
  },
  data() {
    return {
      dataSource: [
        //{ label: "机器型号", key: "deviceId" },
        { label: "用户名", key: "nickname", width: '' },
        // { label: "预警设备编号", key: "machineSn" },
        // { label: "换针申请人", key: "machineUser" },
        // { label: "所属小组", key: "group_id" },
        //{ label: "更换人", key: "user" },
        //{ label: "换针照片", key: "image" },
        //{ label: "负责主管", key: "manager" },
        { label: "最后换针时间", key: "last_change_time" },
        // { label: "操作", key: "menu" },
      ],
      tabelData: [],
      editvisible: false,
      selectrow: {},
      slotmap: ["last_change_time"],
      centerDialogVisible: false,
      centerDialogVisible_image: "",
      numdata: 0,
      current_page: 1,
      page_size: 8,
    };
  },
  methods: {
    handleCurrentChange_next() {
      this.current_page += 1;
    },
    handleCurrentChange_prev() {
      this.current_page -= 1;
    },
    handleCurrentChange(val) {
      this.current_page = val;
      this.getData();
    },
    getData() {
      let params = {};
      if (this.searchval) {
        if (this.searchtype) {
          params = {
            limit: this.page_size, page: this.current_page,
            "search[0][field]": "extra",
            "search[0][val]": this.searchval,
            "search[0][operator]": "LIKE",
            "search[1][field]": "create_time",
            "search[1][val]": this.searchtype,
            "search[1][operator]": "RANGE",
            "search[1][render]": "datetime",
          };
        } else {
          params = {
            limit: this.page_size, page: this.current_page,
            "search[0][field]": "extra",
            "search[0][val]": this.searchval,
            "search[0][operator]": "LIKE",
          };
        }
      } else {
        if (this.searchtype) {
          params = {
            limit: this.page_size, page: this.current_page,
            "search[1][field]": "create_time",
            "search[1][val]": this.searchtype,
            "search[1][operator]": "RANGE",
            "search[1][render]": "datetime",
          };
        } else {
          params = {
            limit: this.page_size, page: this.current_page,
          };
        }
      }
      getpeoWarnlist(params)
        .then((res) => {
          if (res.code == 1) {
            this.tabelData = res.data.list
            this.numdata = res.data.total
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    CheckAlarmType(type) {
      var str = "其他";
      if (type == 1) {
        str = "设备";
      } else if (type == 2) {
        str = "机器";
      }
      return str;
    },
    formatDate(value) {// 时间戳转换日期格式方法
      if (value == null) {
        return '';
      } else {
        value = value * 1000
        let date = new Date(value);
        let y = date.getFullYear();// 年
        let MM = date.getMonth() + 1;// 月
        MM = MM < 10 ? ('0' + MM) : MM;
        let d = date.getDate();// 日
        d = d < 10 ? ('0' + d) : d;
        let h = date.getHours();// 时
        h = h < 10 ? ('0' + h) : h;
        let m = date.getMinutes();// 分
        m = m < 10 ? ('0' + m) : m;
        let s = date.getSeconds();// 秒
        s = s < 10 ? ('0' + s) : s;
        return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
      }
    },
    show_centerDialogVisible(row) {
      this.centerDialogVisible_image = row.image;
      this.centerDialogVisible = true;
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    edit(item) {
      this.selectrow = item;
      this.editvisible = true;
    },
    itemdel() { },
    dialogclose() {
      this.editvisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.tab-menu {
  display: flex;
  align-items: center;
  font-family: Source Han Sans CN;
  font-weight: 500;
  font-size: 14px;
  color: #507af9;
  column-gap: 13px;

  .line {
    width: 1px;
    height: 12px;
    background: #e6e6e6;
  }

  .edit {
    cursor: pointer;
  }

  .delbtn {
    cursor: pointer;
    color: #f95050;
  }
}

.content {
  color: #f95050;
}
</style>